import React from "react"
import {WrappedTOSModal} from "../../features/TOSModal/TOSModal"
import Bugsnag from "@bugsnag/js"
import {useLoginAPI} from "../../hooks/api/useLoginAPI"
import {useSelector} from "react-redux"
import {authSelectors} from "scholastic-client-components/src/slices/authSlice"
import {APIStatus} from "scholastic-client-components/src/types/APITypes"

export const AuthTOSModal: React.FC = () => {
    const login = useLoginAPI()
    const loginStatus = useSelector(authSelectors.getLoginStatus)
    const loginRetryPayload = useSelector(authSelectors.getLoginRetryPayload)

    const retryLogin = () => {
        if (!loginRetryPayload) {
            // eslint-disable-next-line no-console
            console.trace("No login credentials")
            Bugsnag.notify("No login credentials. Unable to retry login from TOS agreement modal.")
            return
        }
        login({...loginRetryPayload, acceptTOS: true})
    }

    return <WrappedTOSModal onAgreeClick={retryLogin} loading={loginStatus === APIStatus.Loading} />
}
